module.exports = __webpack_public_path__ + "assets/fa-regular-400.c20b5b7362d8d7bb7eddf94344ace33e.woff2";